import { useEffect, useCallback } from "react";

const GoogleSSO = ({ setGoogleUser }) => {
  const handleCredentialResponse = useCallback(
    response => {
      console.log("Received Google Sign-In response:", response);
      // Decode the JWT token to get user information
      const decodedToken = decodeJwtResponse(response.credential);
      console.log("Decoded token:", { ...decodedToken, sub: "***" }); // Log token info but hide the sub claim for security

      if (decodedToken.hd === "nativeorange.ai") {
        const userData = {
          email: "testuser",
          name: decodedToken.name,
          picture: decodedToken.picture,
          password: "Python@123" // Using same password as Microsoft SSO for consistency
        };

        setGoogleUser(userData);
      } else {
        console.error(
          "Invalid domain. Only @nativeorange.ai emails are allowed"
        );
        // You might want to show an error message to the user here
      }
    },
    [setGoogleUser]
  );

  useEffect(() => {
    // Load the Google API client library
    const loadGoogleScript = () => {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = initializeGoogleSignIn;
    };

    const initializeGoogleSignIn = () => {
      console.log("Initializing Google Sign-In...");
      if (window.google) {
        try {
          const config = {
            client_id:
              "74624883720-tmo24emo55aht9633gdcsephvdfrqk9v.apps.googleusercontent.com",
            callback: handleCredentialResponse,
            hosted_domain: "nativeorange.ai",
            auto_select: false,
            ux_mode: "popup",
            context: "signin",
            itp_support: true
          };
          console.log("Google Sign-In configuration:", config);
          window.google.accounts.id.initialize(config);

          // Render the Google Sign-In button
          window.google.accounts.id.renderButton(
            document.getElementById("googleButton"),
            {
              type: "standard",
              theme: "outline",
              size: "large",
              text: "continue_with",
              shape: "rectangular",
              width: "200"
            }
          );

          // Also display the One Tap UI
          window.google.accounts.id.prompt();
        } catch (error) {
          console.error("Error initializing Google Sign-In:", error);
        }
      } else {
        console.error("Google API not loaded");
      }
    };

    loadGoogleScript();
  }, [handleCredentialResponse]);

  // handleCredentialResponse is now defined above with useCallback

  const decodeJwtResponse = token => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  // Now using Google's rendered button instead of custom button

  return (
    <div className="text-center mt-2">
      <div
        id="googleButton"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      ></div>
    </div>
  );
};

export default GoogleSSO;
